import React from "react";
import styles from "./index.module.scss";
import { THEME_CHART, THEME_CHART_EN } from "../../constants";

const ChartDataHeroSection = () => {
	return (
		<section className={styles.heroSectionWrapper}>
			<div className={styles.heroTextContainer}>
				<h1>{THEME_CHART}</h1>
				<p>{THEME_CHART_EN}</p>
			</div>
		</section>
	);
};

export default ChartDataHeroSection;
